module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.10938/img/templates-homepage/growth-analytics-icon.svg"